import { IPaginationInfo } from './pagination'

export type IUsersQueryInput = {
  name?: string
  email?: string
  pin?: string
  roles?: string[]
  active?: string
}

export enum EOrganizationType {
  CLIENT = 'CLIENT',
  TENDER_AUTHORITY = 'TENDER_AUTHORITY',
}

export enum EUserRoles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  COMMISSION_MEMBER = 'COMMISSION_MEMBER',
  COMMITTEE_MEMBER = 'COMMITTEE_MEMBER',
  PROCUREMENT_SPECIALIST = 'PROCUREMENT_SPECIALIST',
  ISP_SPECIALIST = 'ISP_SPECIALIST',
  USER = 'USER',
}

export type IUser = {
  id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  active: boolean
  requiresPasswordReset: boolean
  requiresEmailVerification: boolean
  countryCode: string
  identityCardSeries: string
  identityCardNumber: string
  personalIdentificationNumber: string
  organizationId: string
  organizationEmail: string
  position: string
  userRoles: EUserRoles[]
  organizationType: EOrganizationType
  organizationTaxId: string
  fullName: string
}

export type IUsers = {
  info: IPaginationInfo
  items: IUser[]
}
